/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
 
  // {
  //   url: '/dashboard',
  //   name: 'Home',
  //   icon: 'HomeIcon',
  //   slug: 'dashboard-analytics',
  //   i18n: 'Home'
  // },
  // {
  //   header: 'Orders',
  //   icon: 'PackageIcon',
  //   i18n: 'Pedidos',
  //   items: [
      {
        url: '/orders/products',
        name: 'Shop',
        icon: 'ShoppingBagIcon',
        slug: 'products-shop',
        i18n: 'Shop'
      },
      {
        url: '/apps/eCommerce/checkout',
        name: 'ecommerce-checkout',
        icon: 'ShoppingCartIcon',
        slug: 'products-shop',
        i18n: 'Checkout'
      },
      {
        url: '/orders/history',
        name: 'History',
        icon: 'ClockIcon',
        slug: 'history-shop',
        i18n: 'History'
      },
      // {
      //   url: '/payment/history',
      //   name: 'Payments',
      //   icon: 'CreditCardIcon',
      //   slug: 'history-shop',
      //   i18n: 'Payments'
      // }
  //   ]
  // },
  // {
  //   header: 'Support',
  //   icon: 'PackageIcon',
  //   i18n: 'Support',
  //   items: [
  //     {
  //       url: '/support/faq',
  //       slug: 'page-faq',
  //       name: 'FAQ',
  //       icon: 'HelpCircleIcon',
  //       i18n: 'FAQ'
  //     },
  //     {
  //       url: '/support/contacts',
  //       slug: 'page-contacts',
  //       name: 'Contacts',
  //       icon: 'MapIcon',
  //       i18n: 'Contacts'
  //     }
  //   ]
  // }

  
]

